import { jsx as _jsx } from "react/jsx-runtime";
import { BrandConfigurationContext } from './context';
/**
 * The BrandConfigurationProvider makes use of fetchers CachingProvider to ensure that server side data can be passed to the client safety
 * Server side it uses process.env.BRAND
 */
// eslint-disable-next-line
export const BrandConfigurationProvider = ({ children, config }) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return _jsx(BrandConfigurationContext.Provider, { value: config, children: children });
};
